import { deportesDeJugador } from '../../../../lib/deportesJugador'
export const jugadorEnGrupo = (jugador, grupoId) =>
  (jugador?.jugadores_grupos || []).some(
    (jg) => jg.grupo_id === grupoId && jg.activo && !jg.deleted
  )

// La INSCRIPCION manda (spec §8.1). Antes unia grupos + el cache jugadores_meta,
// que podia estar viejo en silencio (la Edge Function que lo escribe se invoca sin
// revisar el error) -- y Uniformes decidia con el.
export const playerDeportes = (jugador) => deportesDeJugador({
  inscripciones: jugador?.temporada_inscripciones,
  jugadoresGrupos: jugador?.jugadores_grupos,
})

export const aggregateAvance = (entregas) => {
  const list = entregas || []
  const total = list.length
  const entregados = list.filter((e) => e.estatus === 'entregado').length
  const sinTalla = list.filter((e) => !e.talla).length
  return { total, entregados, pendientes: total - entregados, sinTalla }
}

export const globalAvance = (entregas) => {
  const { total, entregados, pendientes, sinTalla } = aggregateAvance(entregas)
  const porcentaje = total > 0 ? Math.round((entregados / total) * 100) : 0
  // sinTalla se expone porque es el bloqueo real: no se puede entregar sin talla.
  return { total, entregados, pendientes, sinTalla, porcentaje }
}

export const origenMix = (entregas) => {
  const set = new Set((entregas || []).map((e) => e.origen))
  if (set.has('plan') && set.has('extra')) return 'mixto'
  if (set.has('extra')) return 'extra'
  return 'plan'
}

export const buildTableroCards = (entregas, prendas) => {
  const porPrenda = new Map()
  ;(entregas || []).forEach((e) => {
    if (!porPrenda.has(e.prenda_id)) porPrenda.set(e.prenda_id, [])
    porPrenda.get(e.prenda_id).push(e)
  })
  return (prendas || [])
    .filter((p) => porPrenda.has(p.id))
    .map((p) => {
      const list = porPrenda.get(p.id)
      return { prenda: p, ...aggregateAvance(list), origen: origenMix(list) }
    })
}

export const entregaPasaFiltros = (
  entrega,
  { pagado = 'todos', origen = 'todos' } = {}
) => {
  // Tres estados, no dos. "Sin cobro propio" (prendaPagada == null) NO es "no pago":
  // su costo va dentro del total del plan y no hay un cobro que consultar. Juntarlos
  // en un solo "No pagado" hacia que el filtro mintiera igual que el badge.
  if (pagado !== 'todos') {
    const p = entrega.prendaPagada
    if (pagado === 'pagado' && p !== true) return false
    if (pagado === 'sin_pagar' && p !== false) return false
    if (pagado === 'sin_cobro' && p != null) return false
    // 'no_pagado' (legado): todo lo que no esta confirmado como pagado.
    if (pagado === 'no_pagado' && p === true) return false
  }
  if (origen !== 'todos' && entrega.origen !== origen) return false
  return true
}
